import 'channels';
import 'controllers';
import 'jquery-ui';
import 'jquery-ui-dist/jquery-ui.min.css';
import '../application/javascripts/index.js';
import '../application/stylesheets/application.css.scss';
import '../stylesheets/application.scss';
import 'jquery-mask-plugin';
